<template>
  <div class="config column mt-sm-2">
    <div :class="computedClassHeader">Configuração / Logs</div>
    <div class="" :class="computedClass">
      <div class="col-xs-12 col-sm-4 mt-2">
        <b-card align="center">
          <header slot="header">
            <h4>Servidor</h4>
          </header>
          <div class="card-text start-xs">
            <p><strong>STATUS:</strong> {{ uptimeInfo.NODE.status }}</p>
            <p><strong>UPTIME:</strong> {{ uptime }}</p>
            <p><strong>RESTART:</strong> {{ uptimeInfo.NODE.restart_time }}</p>
            <p>
              <strong>LOOP DELAY:</strong>
              {{ uptimeInfo.NODE.delay.replace("ms", "") }} ms
            </p>
            <p><strong>MEMÓRIA:</strong> {{ memory }}</p>
            <p><strong>CPU:</strong> {{ uptimeInfo.NODE.cpu }} %</p>
          </div>
          <footer slot="footer" class="row center-xs">
            <b-btn @click="openNodeLogs()" variant="3v3" size="sm"
              ><eye-icon title=""
            /></b-btn>
          </footer>
        </b-card>
      </div>
      <div class="col-xs-12 col-sm-4 mt-2">
        <b-card >
          <header slot="header" align="center">
            <h4>Sistema</h4>
          </header>
          <div class="card-text start-xs">
            <p><strong>UPTIME:</strong> {{ uptimeInfo.LINUX }}</p>
            <p><strong>Versão:</strong> {{ sirVersion }}</p>
          </div>
          <footer slot="footer" class="row center-xs">
            <b-btn size="sm" @click="openSystemLogs()" variant="3v3"
              ><eye-icon title=""
            /></b-btn>
          </footer>
        </b-card>
      </div>
      <div class="col-xs-12 col-sm-4 mt-2">
        <b-card >
          <header slot="header" align="center">
            <h4>Firmware</h4>
          </header>
          <div class="card-text">
            <p>
              <strong>STATUS:</strong> {{ statusCir ? "ativo" : "inativo" }}
            </p>
            <div v-if="fwInfo.GENERIC">
              <span v-for="(g, i) in fwInfo.GENERIC" :key="i">
                <p>
                  <strong>{{ g.NAME }}</strong> {{ g.VALUE }}
                </p>
              </span>
            </div>
          </div>
          <footer slot="footer" class="row center-xs">
            <b-btn size="sm" @click="openFirmwareLogs()" variant="3v3"
              ><eye-icon title=""
            /></b-btn>
          </footer>
        </b-card>
      </div>
      <div v-if="showForm">
        <div id="overlay" @click="showForm = false"></div>
        <div id="form">
          <h5>{{ type }}</h5>
          <div class="col-xs-12">
            {{ logs }}
          </div>
          <footer id="footer">
            <b-btn size="sm" block @click="showForm = false"> Fechar </b-btn>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { logs, info } from "@/api";

export default {
  name: "logs",
  created() {
    logs
      .uptimeInfo()
      .then((ret) => {
        this.uptimeInfo = ret;
      })
      .catch((err) => console.log(err));
    info
      .sirVersion()
      .then((ret) => {
        this.sirVersion = ret;
        return info.firmwareInfo();
      })
      .then((ret) => (this.fwInfo = ret))
      .catch((err) => console.log(err));
  },
  props: {
    statusCir: [Boolean],
    mobile: Boolean,
  },
  data() {
    return {
      type: "",
      showForm: false,
      logs: "-\n",
      uptimeInfo: {
        LINUX: "-\n",
        NODE: {
          cpu: null,
          memory: null,
          delay: "-",
          uptime: null,
          restart_time: null,
          status: "-",
        },
      },
      fwInfo: {
        GENERIC: [],
      },
      sirVersion: "-",
    };
  },
  computed: {
    computedClass() {
      if (this.mobile) {
        return "container-cards mobile-header";
      }
      return "container-cards desktop-header mt-2";
    },
    computedClassHeader() {
      if (this.mobile) {
        return "page-title config-title-mobile col-xs-12  mt-0";
      }
      return "page-title config-title col-xs-12  mt-2";
    },
    uptime() {
      let days = Math.floor(this.uptimeInfo.NODE.uptime / 86400000);
      let hours = Math.floor((this.uptimeInfo.NODE.uptime / 3600000) % 24);
      let minutes = Math.floor((this.uptimeInfo.NODE.uptime / 60000) % 60);

      return days + "d " + hours + "h " + minutes + "m";
    },
    memory() {
      return (this.uptimeInfo.NODE.memory / 1048576).toFixed(1) + " MB";
    },
  },
  methods: {
    openNodeLogs() {
      this.type = "Servidor";
      logs
        .nodeLogs()
        .then((ret) => (this.logs = ret))
        .catch((err) => console.log(err));
      this.showForm = true;
    },
    openSystemLogs() {
      this.type = "Sistema";
      logs
        .kernelLog()
        .then((ret) => (this.logs = ret))
        .catch((err) => console.log(err));
      this.showForm = true;
    },
    openFirmwareLogs() {
      this.type = "Firmware";
      logs
        .fwLog()
        .then((ret) => (this.logs = ret))
        .catch((err) => console.log(err));
      this.showForm = true;
    },
  },
};
</script>

<style scoped>
.logs {
  max-height: 400px;
  overflow-y: auto;
}
.mobile-header{
  margin-top: 40px;
}
strong {
  text-transform: uppercase;
}
.card-text > div > p {
  color: var(--text-gray-primary);
}

.config-title{
  max-height: 1.1em;
  /* padding: 0 0 4px 0; */
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
@media screen and (max-width: 767px) {
  .card-text {
    font-size: 0.88em;
  }
}
</style>
